import React, { useState, useEffect, useRef } from "react";
import MailIcon from "./img/mailsvg.svg";
import { Alert, Button, Col, Form, FormGroup, InputGroup, Row, Spinner } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { emailRegex, header, host } from "./globalVariables";

import { api } from "./pureFunctions";
const debouncetime = 600;
import { useDebouncedCallback } from "use-debounce";
import ErrorCheckbox from "./ErrorCheckbox";
import HinweisWrapper from "./HinweisWrapper";
import { useConfig } from "./ConfigContext";
import { sendMail } from "./networkFunctions";

const initialMail = `Guten Tag,
anbei die geforderten Dateien zum Herunterladen. 

Mit freundlichen Grüßen

`;

export default function EmailVersand({
   teamsChannelNotification,
   setMailWarteschleife,
   mailWarteschleife,
   user,
   postMsSharelink,
   sharepointIDs,
   sharepointObject,
   spLink,
   estateId,
}) {
   const config = useConfig();

   const [showUbersicht, setShowUbersicht] = useState(false);
   const [selectedFiles, setSelectedFiles] = useState({});
   const [addressList, setAddressList] = useState([]);
   const [mailStatus, setMailStatus] = useState();
   const [message, setMessage] = useState();
   const [mailReceiver, setMailReceiver] = useState([]);
   const [searchMailReceiver, setSearchMailReceiver] = useState("");
   const [redactWarteschleife,setRedactWarteschleife]=useState([])

   const debounced = useDebouncedCallback((value) => {
      getAddress(value);
   }, debouncetime);

   useEffect(() => {
      if (user && !message) {
         setMessage(initialMail + "" + user.Vorname + " " + user.Nachname);
      }
   }, [user]);

   async function getAddress(name) {
      let addressParameters = {
         data: ["Vorname", "Name", "KdNr", "email"],
         filter: isNaN(name)
            ? {
                 Name: [
                    {
                       op: "like",
                       val: "%" + name + "%",
                    },
                 ],
              }
            : {
                 KdNr: [
                    {
                       op: "like",
                       val: name + "%",
                    },
                 ],
              },
         listlimit: 100,
         sortorder: "ASC",
      };

      console.log(addressParameters);

      await api
         .post("/api/getfilteredaddresses", { parameters: addressParameters })
         .then((data) => {
            console.log(data);

            let addressArray = data.data
               .map((adItem) =>
                  Object.keys(adItem.elements).reduce((oldArr, mailItem) => {
                     return mailItem.includes("email")
                        ? [
                             ...oldArr,
                             {
                                id: adItem.id,
                                KdNr: adItem.elements.KdNr,
                                name: adItem.elements.Name,
                                vorname: adItem.elements.Vorname,
                                email: adItem.elements[mailItem],
                             },
                          ]
                        : [...oldArr];
                  }, []),
               )
               .flat();

            console.log(addressArray);
            setAddressList(addressArray);
         })
         .catch((err) => {
            console.log(err);
         });
   }

   async function getAllShareableLinks() {
      console.log(sharepointObject);
      console.log(sharepointIDs);

      const publicFiles = Object.values(sharepointIDs)
         .flat()
         .filter((item) => item.public2)
         .map((item) => sharepointObject[item.name])
         .filter((item) => item);
      console.log(publicFiles);

      let newPublicLinks = [];

      const promises = publicFiles.map(async (fileItem) => {
         console.log(fileItem);

         try {
            const linkData = await postMsSharelink(fileItem.id, fileItem.parentReference.driveId);

            fileItem.publicLink = { name: fileItem.name, link: linkData.link.webUrl };

            return { name: fileItem.name, link: linkData.link.webUrl };
         } catch (error) {
            console.log(error);
            console.log(fileItem);

            fileItem.publicLink = "error";

            return "error";
         }
         // fileItem.publicLink
      });

      const results = await Promise.all(promises);
      console.log(results);

      console.log(publicFiles);
      setSelectedFiles(publicFiles.reduce((oldObj, item) => ({ ...oldObj, [item.id]: item }), {}));
   }

   async function prepareMail(mailSubject, myRedactWarteschleife, receiver) {
      let teamsMessage = {
         channelId: "19%3Ad72a3e2d58e7447296b7f42c3a085e9c%40thread.tacv2",
         content:
            '<div>Bitte folgende Dateien schwärzen  <a style="font-size: 16px; font-weight: bold;" href="https://programme.baur-immobilien.de/datenblatt?estateid=$Id$">$ind_3274_Feld_ObjIndividualCategoryFields281$</a></div>',
         contentData: ["Id", "ind_3274_Feld_ObjIndividualCategoryFields281"],
      };
      teamsChannelNotification(teamsMessage);
   }



   async function sendFileMail(mailSubject, receiver) {
      setMailStatus("loading");

      console.log(selectedFiles);

      // selectedFiles
      let mailContent = (
         message +
         " <div><br/>" +
         (Object.values(selectedFiles).length > 0
            ? `</div><hr size="2" color="${config.colorScheme.signature}"/><br/><br/>Die Dateien sind 14 Tage unter den folgenden Links erreichbar:<br/>`
            : "") +
         Object.values(selectedFiles)
            .map((file) => `<a href="${file.publicLink.link}">${file.publicLink.name}</a> `)
            .join("<br/>") +
         `<br/><hr size="2" color="${config.colorScheme.signature}"/>`
      ).replace(/\n/g, "<br />");

      console.log(mailContent);

      await sendMail(estateId, mailSubject, mailContent, receiver, setMailStatus)
/* 
      let mailData = {
         emailidentity: "info@baur-immobilien.de",
         displayName: "Baur Immobilien",
         useHtml: true,
         // receiver: [element.email],
         // receiver: ["it@baur-immobilien.de"],
         receiver: receiver.map((item) => ({ addressid: "" + item.id, email: item.email })),
         estateids: [estateId],
         body: mailContent,
         subject: mailSubject,
         signatureid: 0,
         // bcc: receiver.map((item) => item.email),
         handleReceiversSeparately: true,
         // ...(index === 0 ? { bcc: ["it@baur-immobilien.de"] } : {}),
      };
      console.log(mailData);

      await api
         .post("/api/sendEmail", mailData, header)
         .then((data) => {
            console.log(data);
            setMailStatus("success");
         })
         .catch((err) => {
            setMailStatus("error");
            console.log(JSON.stringify(err.response.data, null, 1));
            console.error({
               error: "onOffice",
               message: JSON.stringify(err.response.data, null, 1),
            });
         }); */
   }

   function addToRedactionList(newListItem) {
      console.log(newListItem);
      setRedactWarteschleife((prev) =>
         prev.includes(newListItem) ? prev.filter((item) => item !== newListItem) : [...prev, newListItem],
      );
   }
   return (
      <>
         <div className="file-buttongroup">
            <button
               disabled={false}
               className="custom-button my-1"
               style={showUbersicht ? { boxShadow: "0 0 4px 6px #CFE2FF" } : {}}
               title="Dateien anzeigen/verbergen"
               onClick={(e) => {
                  e.preventDefault();
                  setShowUbersicht(true);
                  console.log(user);
               }}
            >
               <img src={MailIcon} />
            </button>
         </div>

         <Modal show={showUbersicht} size="xl" onHide={() => setShowUbersicht(false)}>
            <Modal.Body>
               {mailStatus === "success" ? (
                  <Alert variant="success">Die Email wurde versendet!</Alert>
               ) : (
                  <div className="nachrichten-ubersicht">
                     {Object.keys(sharepointIDs).length > 0 && (
                        <>
                           <h3>
                              <img className="me-3" src={MailIcon} height={36} />
                              Dateien per E-Mail versenden
                           </h3>
                           <HinweisWrapper storageKey="emailversand">
                              <div>
                                 Im Empfängerfeld bitte mit dem <strong>Nachnamen</strong> suchen und dann den passenden
                                 Kontakt aus der Liste auswählen.
                                 <br />
                                 Dabei ist es auch möglich mehrere Empfänger nacheinander auszuwählen.
                                 <br />
                                 Zum Abwählen einfach nochmal auf den ausgewählten Kontakt klicken.
                              </div>
                              <div>
                                 Um der Mail <strong>alle</strong> freigebenen Dateien anzuhängen, einfach auf den Knopf
                                 drücken.
                              </div>
                              <div>
                                 Zum An-/Abwählen einzelner Dateien, bitte rechts auf den quadratischen Knopf klicken.
                                 <ul>
                                    <li>Wird er grün, wird die Datei mit versendet</li>
                                    <li>
                                       Ist er rot, gab es einen Fehler beim Anhängen. Ggf. hilft es die Datei noch
                                       einmal ab- und wieder anzuwählen.
                                    </li>
                                 </ul>
                                 Zum Abwählen erneut auf den Knopf drücken, sodass er grau wird.
                              </div>
                           </HinweisWrapper>
                           <Form className="mt-3">
                              <Row>
                                 <FormGroup as={Col} className="mb-3">
                                    <Form.Label>Empfänger</Form.Label>
                                    <Form.Control
                                       autoComplete="off"
                                       type="email"
                                       className={emailRegex.test(searchMailReceiver) ? "" : " empty-field"}
                                       onChange={(e) => {
                                          setSearchMailReceiver(e.target.value);
                                          debounced(e.target.value);
                                       }}
                                       value={searchMailReceiver}
                                    />
                                    {mailReceiver.length > 0 && (
                                       <div className="mt-1">
                                          {mailReceiver.map((item, index) => (
                                             <Button
                                                key={"mailsendkey_" + index}
                                                variant="dark"
                                                onClick={() => {
                                                   setMailReceiver((prev) =>
                                                      prev.filter((receiver) => receiver.email != item.email),
                                                   );
                                                }}
                                                className="text-start mb-1 me-1"
                                             >
                                                <strong>{item.email}</strong>
                                                {" | "}
                                                <small>{item.KdNr + ": " + item.vorname + " " + item.name}</small>
                                                {" | "} &times;
                                             </Button>
                                          ))}
                                       </div>
                                    )}

                                    {addressList.length > 0 && (
                                       <div className="p-2">
                                          {addressList.map((item, index) => (
                                             <Button
                                                key={"mailsendkey_" + index}
                                                variant="outline-secondary"
                                                // active={item.email === mailReceiver}
                                                onClick={() => {
                                                   setMailReceiver((prev) => [...prev, item]);
                                                   setSearchMailReceiver("");
                                                   setAddressList([]);

                                                   // debounced(e.target.value);
                                                }}
                                                className="w-100 text-start"
                                             >
                                                <strong>{item.email}</strong>
                                                {" | "}
                                                <small>{item.KdNr + ": " + item.vorname + " " + item.name}</small>
                                             </Button>
                                          ))}
                                       </div>
                                    )}
                                 </FormGroup>
                              </Row>
                              <Form.Label>Nachricht</Form.Label>
                              <InputGroup className="mb-3">
                                 <Form.Control
                                    as="textarea"
                                    className={message ? "" : " empty-field"}
                                    placeholder=""
                                    onChange={(e) => {
                                       setMessage(e.target.value);
                                    }}
                                    value={message}
                                    style={{ minHeight: "300px", fieldSizing: "content" }}
                                 />
                              </InputGroup>
                           </Form>
                           <div className="">
                              <Button
                                 className="w-100 mb-2"
                                 variant="dark"
                                 style={{ borderRadius: "4px" }}
                                 onClick={async () => {
                                    setMailStatus("loading");
                                    await getAllShareableLinks();
                                    setMailStatus();
                                 }}
                              >
                                 Alle freigegebenen Dateien auswählen
                              </Button>
                           </div>
                           {Object.keys(sharepointIDs).map((kachel) => (
                              <div key={"spDateiuberkey_" + kachel} className="kachel-notizbereich p-0">
                                 <h5>{kachel}</h5>
                                 {sharepointIDs[kachel] &&
                                    sharepointIDs[kachel].map((spDatei, index2) => {
                                       return (
                                          <div
                                             className="kachel-notiz"
                                             // style={spDatei.public2 ? {} : { opacity: 0.5, filter: "saturate(0.5)" }}
                                             key={"spDatkey_" + index2}
                                          >
                                             {sharepointObject && sharepointObject[spDatei.name] && (
                                                <>
                                                   {spDatei.public2 ? (
                                                      <div>
                                                         <label
                                                            className="checkbox-container"
                                                            style={{
                                                               display: "flex",
                                                               flexDirection: "row",
                                                               justifyContent: "space-between",
                                                               margin: "0 32px",
                                                            }}
                                                         >
                                                            <a
                                                               target="_blank"
                                                               className="p-1"
                                                               style={{ fontWeight: 700 }}
                                                               href={sharepointObject[spDatei.name].webUrl}
                                                            >
                                                               {sharepointObject[spDatei.name].name} ↗
                                                            </a>
                                                            <ErrorCheckbox
                                                               loading={mailStatus === "loading"}
                                                               value={
                                                                  selectedFiles[sharepointObject[spDatei.name].id] &&
                                                                  selectedFiles[sharepointObject[spDatei.name].id]
                                                                     .publicLink
                                                               }
                                                               onChange={async (e) => {
                                                                  console.log(spDatei);
                                                                  let newSelected = structuredClone(selectedFiles);
                                                                  if (newSelected[sharepointObject[spDatei.name].id]) {
                                                                     delete newSelected[
                                                                        sharepointObject[spDatei.name].id
                                                                     ];
                                                                  } else {
                                                                     setMailStatus("loading");
                                                                     await postMsSharelink(
                                                                        sharepointObject[spDatei.name].id,
                                                                        // "123123",
                                                                        sharepointObject[spDatei.name].parentReference
                                                                           .driveId,
                                                                     )
                                                                        .then((resp) => {
                                                                           newSelected[
                                                                              sharepointObject[spDatei.name].id
                                                                           ] = {
                                                                              ...sharepointObject[spDatei.name],
                                                                              publicLink: {
                                                                                 name: sharepointObject[spDatei.name]
                                                                                    .name,
                                                                                 link: resp.link.webUrl,
                                                                              },
                                                                           };
                                                                        })
                                                                        .catch((err) => {
                                                                           console.log(err);
                                                                           newSelected[
                                                                              sharepointObject[spDatei.name].id
                                                                           ] = {
                                                                              ...sharepointObject[spDatei.name],
                                                                              publicLink: "error",
                                                                           };
                                                                        });
                                                                  }
                                                                  console.log(newSelected);
                                                                  setSelectedFiles(newSelected);
                                                                  setMailStatus("");
                                                               }}
                                                            />
                                                         </label>
                                                      </div>
                                                   ) : (
                                                      <div
                                                         style={{
                                                            display: "flex",
                                                            flexDirection: "row",
                                                            justifyContent: "space-between",
                                                            margin: "0 32px",
                                                         }}
                                                      >
                                                         <a
                                                            target="_blank"
                                                            className="p-1"
                                                            style={{ color: "#555" }}
                                                            href={sharepointObject[spDatei.name].webUrl}
                                                         >
                                                            {sharepointObject[spDatei.name].name} ↗
                                                         </a>
                                                         <div>
                                                            {/* <Button
                                                               variant={
                                                                  redactWarteschleife?.includes(spDatei.name)
                                                                     ? "outline-dark"
                                                                     : "dark"
                                                               }
                                                               onClick={() => {
                                                                  addToRedactionList(spDatei.name);
                                                               }}
                                                            >
                                                               schwärzen
                                                            </Button> */}
                                                            (nicht freigegeben)
                                                         </div>
                                                      </div>
                                                   )}
                                                </>
                                             )}
                                          </div>
                                       );
                                    })}
                              </div>
                           ))}
                        </>
                     )}
                  </div>
               )}
            </Modal.Body>

            <Modal.Footer>
               <Button
                  variant="secondary"
                  onClick={() => {
                     setShowUbersicht(false);
                     setMailStatus(false);
                  }}
               >
                  Schließen
               </Button>

               {message &&
                  emailRegex.test(mailReceiver.length && mailReceiver[0].email) &&
                  !(mailStatus === "success") && (
                     <>
                        {redactWarteschleife.length ? (
                           <Button
                              disabled={mailStatus === "loading"}
                              variant="warning"
                              onClick={async () => {
                                 await prepareMail(
                                    "Dateien zum _objekttyp Objekt _objektnr_extern in _ort",
                                    redactWarteschleife,
                                    mailReceiver,
                                 );
                                 setMailReceiver([]);
                                 setSearchMailReceiver("");
                                 setAddressList([]);
                                 setSelectedFiles([]);
                              }}
                           >
                              Schwärzung und Emailversand beauftragen.
                           </Button>
                        ) : (
                           <Button
                              disabled={mailStatus === "loading"}
                              variant="danger"
                              onClick={async () => {
                                 await sendFileMail("Dateien zum _objekttyp Objekt _objektnr_extern in _ort", mailReceiver);

                                 setMailReceiver([]);
                                 setSearchMailReceiver("");
                                 setAddressList([]);
                                 setSelectedFiles([]);
                              }}
                           >
                              Email mit ausgewählten Dateien versenden.
                           </Button>
                        )}
                     </>
                  )}
            </Modal.Footer>
         </Modal>
      </>
   );
}
